import { render, staticRenderFns } from "./SerialNumberPage.vue?vue&type=template&id=64454233"
import script from "./SerialNumberPage.vue?vue&type=script&lang=js"
export * from "./SerialNumberPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports